module.exports = __webpack_public_path__ + "img/OverseaMember09.5ce90fcb.jpg";